import { Link } from "react-router-dom";

export default function Description() {
    return (
        <div className="description">
            <article>
                <h3 className="hello">Bonjour, je suis</h3>
                <h1 className="name">Bilal LAGHMAM</h1>
                <h1 className="domaine">Développeur web Full Stack</h1>
            </article>

            <article>
                {/* <p className="myDesc">
                    J'excelle dans la collaboration avec des équipes diverses et je m'épanouis dans des environnements dynamiques. Mon adaptabilité, ma bonne communication et ma capacité à apprendre rapidement me permettent de travailler efficacement avec des collègues de différents horizons.
                </p> */}
                
                <Link to="https://drive.google.com/file/d/1J8-TYPgw66Be0DqDOOXRfKOHdDKEWrXH/view?usp=drive_link" target="_blank"><button className="download">Mon CV</button></Link>
            </article>
        </div>
    )
}